import { useParams } from "react-router-dom";
import NoAccessPage from "./NoAccessPage";
import ProtectedRoute from "./ProtectedRoute";
import PowerBIReport from "../powerbi/PowerBIReport";
import { POWERBI_CCMR_INTERNAL_VIEW, POWERBI_CCMR_SLA_REPORTING_VIEW, POWERBI_DQ_INSIGHTS_VIEW } from "./permission-consts";
import { REPORT_IDs } from "../../utils/LS-CONSTANT";

const PowerBIWrapper = () => {
  const { report } = useParams();

  const config = {
    ccmr: {
      permission: POWERBI_CCMR_INTERNAL_VIEW,
      reportId: REPORT_IDs.ccmr,
    },
    dq: {
      permission: POWERBI_DQ_INSIGHTS_VIEW,
      reportId: REPORT_IDs.dq,
    },
    ["ccmr-sla"]: {
      permission: POWERBI_CCMR_SLA_REPORTING_VIEW,
      reportId: REPORT_IDs["ccmr-sla"],
    },
  };

  const item = config[report];
  console.log("PowerBIWrapper - report param:", item);

  if (!item) return <NoAccessPage />;

  return (
    <ProtectedRoute permission={item.permission}>
      <PowerBIReport reportId={item.reportId} />
    </ProtectedRoute>
  );
};

export default PowerBIWrapper;